/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Default_DescriptionInputs */

const en_faq_default_description = /** @type {(inputs: Faq_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check out the FAQs below for everything you need to know!`)
};

const es_faq_default_description = /** @type {(inputs: Faq_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Consulta las preguntas frecuentes a continuación para todo lo que necesitas saber!`)
};

/**
* | output |
* | --- |
* | "Check out the FAQs below for everything you need to know!" |
*
* @param {Faq_Default_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_default_description = /** @type {((inputs?: Faq_Default_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Default_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_default_description(inputs)
	return en_faq_default_description(inputs)
});